import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { usuarioPodeAcessarConfiguracoes } from "../utils/permissoes";

export function RotaDonoPlataforma({ children }: { children: ReactNode }) {
  const { usuario, carregando } = useAuth();

  if (carregando) return null;
  if (!usuarioPodeAcessarConfiguracoes(usuario)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
